import CbSmallBox from './src/small-box.vue';

CbSmallBox.install = function(Vue) {
  Vue.component(CbSmallBox.name, CbSmallBox);
};

export default CbSmallBox;
